var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6875 34C32.4489 34 34.6875 31.7614 34.6875 29V28.6111H30.5875L28.2889 26.2778L26.1667 28.6111H12.6444V17.7333H8.27778L13.6889 5.47778H18.9111L20.7778 9.67778V5.47778H27.2444L28.3667 8.64444L29.5 5.47778H34.6875V5C34.6875 2.23858 32.4489 0 29.6875 0H5.5C2.73858 0 0.5 2.23858 0.5 5V29C0.5 31.7614 2.73858 34 5.5 34H29.6875ZM31.2764 27.2444H34.6875L29.9889 22.4556L34.6875 17.7222H31.3319L28.3556 20.7778L25.6 17.7333H22.1889L26.6778 22.4889L22.1889 27.2444H25.5L28.3 24.1778L31.2764 27.2444ZM32.0764 22.4667L34.6875 25.2444V19.7111L32.0764 22.4667ZM16.6778 25.0444V23.5667H22.0444V21.4222H16.6778V19.9444H22.1778V17.7444H14.0778V27.2556H22.1778V25.0556H16.6778V25.0444ZM32.1208 16.3556H34.6875V6.84444H30.6875L28.3667 12.7667L26.2444 6.84444H22.1778V16.3556H24.7444V9.68889L27.1889 16.3444H29.4778L32.1097 9.66667V16.3556H32.1208ZM19.2667 16.3556H22.1889L17.9889 6.84444H14.6444L10.4444 16.3556H13.3L14.0889 14.4556H18.4667L19.2667 16.3556ZM17.5667 12.3222H14.9889L16.2778 9.21111L17.5667 12.3222Z",
    fill: "#C9CCD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.a5553d6aef71eab5a81324fb5999538f.svg";
export { ForwardRef as ReactComponent };